import { render, staticRenderFns } from "./get-in-touch.vue?vue&type=template&id=4b0528cf&scoped=true&"
import script from "./get-in-touch.vue?vue&type=script&lang=js&"
export * from "./get-in-touch.vue?vue&type=script&lang=js&"
import style0 from "./get-in-touch.vue?vue&type=style&index=0&id=4b0528cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0528cf",
  null
  
)

export default component.exports